import React from 'react';
import { connect} from 'react-redux';
import { NavContainer } from './nav';
import { MobileNavContainer } from './mobile-nav';
import { FooterContainer } from './footer';

const { Component } = React;

import css from '../styles/app.css';

class App extends Component {
  render() {
    return (
      <div className="app__wrapper">
        < NavContainer />
        < MobileNavContainer />
        { React.cloneElement(this.props.children, this.props) }
        < FooterContainer />
      </div>
    );
  }
}

export { App };



// WEBPACK FOOTER //
// ./app/screens/App/components/app.js